/* eslint-disable react/no-danger */
import React from "react";
import PatioConfigurator from "components/patio-configurator";

const Patio = ({ product, onVariantChange, quantity, handleQuantityChange, onAddToCart, patioConfig, variantColors }) => (
    <PatioConfigurator
        product={product}
        handleQuantityChange={handleQuantityChange}
        quantity={quantity}
        onVariantChange={onVariantChange}
        onAddToCart={onAddToCart}
        variantColors={variantColors}
        patioConfig={patioConfig}
    />
);

export default Patio;
